const routes = {
    HOME: '/',
    ADDRESSUSER: '/addressUser',
    CART: '/cart',
    CHECKOUT: '/checkout',
    LOGIN: '/login',
    PRODUCT: '/products/:productId',
    PRODUCTSEARCH: '/products/search/:keySearch',
    PROFILE: '/profile',
    SIGNUP: '/signup',
    FORGOT_PASSWORD: '/forgot_password',
    SHOP: '/shop',
    SHOPCATEGOTY: '/shop/:categoryId',
    TRACKINGORDER: '/trackingOrder',
};

export default routes;
